jQuery(document).ready(function($){
	var elems = document.querySelectorAll('.splide.slider:not([data-splide-ignore])');

	if (elems.length) {
		elems.forEach(function (elem) {
			console.log(elem.classList);
			console.log(elem.classList.contains('featured'));
			let slider = new Splide(elem, {
				type: 'loop',
				perPage: 1,
				gap: '2rem',
				arrows: {
                    prev: '.splide__arrow--prev',
                    next: '.splide__arrow--next',
                },
				pagination: true,
				trimSpace: true,
				arrows: true,
				arrowPath: 'm14.2928932 10.2928932c.3905243-.39052427 1.0236893-.39052427 1.4142136 0l9 9 .7071068.7071068-9.7071068 9.7071068c-.3905243.3905243-1.0236893.3905243-1.4142136 0s-.3905243-1.0236893 0-1.4142136l8.2921068-8.2928932-8.2921068-8.2928932c-.3604839-.360484-.3882135-.927715-.0831886-1.3200062z',
				classes: {
					arrows: 'splide__arrows',
					arrow: 'splide__arrow',
					prev: 'splide__arrow--prev',
					next: 'splide__arrow--next',
					pagination: 'splide__pagination',
					page: 'splide__pagination__page',
				},
				breakpoints: {
					1024: {
						gap: '1.5rem',
					}
				}
			});

            slider.on('pagination:mounted', function(data) {
                
            });


            //Featured rules
            if(elem.classList.contains('featured')) {
				let rafId;

				function updateZoom() {
					const Slides = slider.Components.Slides.get();
					const Move   = slider.Components.Move;
					const Layout = slider.Components.Layout;
					const pos    = Move.getPosition();
					const viewportC = -pos + Layout.listSize() / 2;

					// Find the slide closest to center
					let distances = Slides.map((Slide) => {
						const slideEl = Slide.slide;
						const slideSize = slideEl.offsetWidth;
						const slideC = slideEl.offsetLeft + slideSize / 2;
						const distance = Math.abs(slideC - viewportC);
						return { Slide, slideEl, distance };
					});

					distances.sort((a, b) => a.distance - b.distance);

					const centerSlide = distances[0].slideEl;
					const neighbors   = [distances[1]?.slideEl, distances[2]?.slideEl].filter(Boolean);

					Slides.forEach((Slide) => {
						const slideEl = Slide.slide;
						const innerEl = slideEl.querySelector('.scfe-block-wrapper.carousel-slide');
						if (!innerEl) return;

						const slideSize = slideEl.offsetWidth;
						const slideC    = slideEl.offsetLeft + slideSize / 2;
						const distance  = Math.abs(slideC - viewportC);
						const factor    = Math.min(distance / slideSize, 1);
						const eased     = Math.pow(factor, 0.85);

						const maxScale = parseFloat('1.2');
						const minScale = parseFloat('0.8');
						const minOpacity = parseFloat('0.6');

						let scale, opacityOffset;
						if (slideEl === centerSlide) {
							scale = maxScale; // center slide zoomed
							opacityOffset = 0;
						} else if (neighbors.includes(slideEl)) {
							scale = (maxScale + minScale) / 2;
							opacityOffset = (1 - minOpacity) / 2;
						} else {
							scale = maxScale - (maxScale - minScale) * eased;
							opacityOffset = 1 - minOpacity;
						}

						const isDragging = slider.state.isDragging;
						innerEl.style.transition = isDragging ? 'transform 0s, opacity 0s' : 'transform 500ms, opacity 500ms';
						innerEl.style.transform  = `scale(${scale})`;
						innerEl.style.opacity    = (1 - opacityOffset * eased).toString();
						innerEl.style.zIndex     = String(Math.round(scale * 1000));
						innerEl.style.transformOrigin = 'center center';
						innerEl.style.willChange = 'transform';
					});
				}

				function startAnimLoop() {
					if (rafId) return;
					const tick = () => {
						updateZoom();
						rafId = requestAnimationFrame(tick);
					};
					tick();
				}

				function stopAnimLoop() {
					if (rafId) cancelAnimationFrame(rafId);
					rafId = null;
					updateZoom(); // final settle
				}

				// hooks
				slider.on('mounted', startAnimLoop);
				slider.on('resize updated', updateZoom);
				slider.on('drag', startAnimLoop);
				slider.on('dragging', updateZoom);
				slider.on('dragged', stopAnimLoop);
				slider.on('move', startAnimLoop);
				slider.on('moved', stopAnimLoop);
            }

            slider.mount();

			// Listen for your sidebar toggle event
			document.addEventListener('sidebarToggled', function() {
				setTimeout(() => {
					slider.refresh();
				}, 300); // optional delay, match your sidebar animation duration
			});
		});
	}

});